"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationModel = void 0;
const ide_lib_reactor_data_layer_1 = require("@journeyapps-platform/ide-lib-reactor-data-layer");
const mobx_1 = require("mobx");
const ContainerDepotTokenModel_1 = require("./ContainerDepotTokenModel");
const PaymentConfigurationModel_1 = require("./PaymentConfigurationModel");
const V5BaseModel_1 = require("./base/V5BaseModel");
let OrganizationModel = (() => {
    var _a, _OrganizationModel_billingDetails_accessor_storage;
    let _classSuper = V5BaseModel_1.V5BaseModel;
    let _billingDetails_decorators;
    let _billingDetails_initializers = [];
    let _billingDetails_extraInitializers = [];
    return _a = class OrganizationModel extends _classSuper {
            get billingDetails() { return __classPrivateFieldGet(this, _OrganizationModel_billingDetails_accessor_storage, "f"); }
            set billingDetails(value) { __classPrivateFieldSet(this, _OrganizationModel_billingDetails_accessor_storage, value, "f"); }
            constructor(options) {
                super('organization', options);
                _OrganizationModel_billingDetails_accessor_storage.set(this, __runInitializers(this, _billingDetails_initializers, void 0));
                __runInitializers(this, _billingDetails_extraInitializers);
                this.apps = new ide_lib_reactor_data_layer_1.PaginatedCollection({
                    transformer: (0, mobx_1.action)((res) => {
                        return res.objects.map((app) => this.options.banks.appsBank.upsert(app));
                    })
                });
                this.developers = new ide_lib_reactor_data_layer_1.PaginatedCollection({
                    transformer: (0, mobx_1.action)((res) => {
                        return res.objects.map((user) => this.options.banks.developerBank.upsert(user));
                    })
                });
                this.roles = new ide_lib_reactor_data_layer_1.PaginatedCollection({
                    transformer: (0, mobx_1.action)((res) => {
                        return res.items.map((role) => this.options.banks.roleBank.upsert(role));
                    })
                });
                this.developerInvites = new ide_lib_reactor_data_layer_1.PaginatedCollection({
                    transformer: (0, mobx_1.action)((res) => {
                        return res.objects.map((invite) => this.options.banks.developerInviteBank.upsert(invite));
                    })
                });
                this.tickets = new ide_lib_reactor_data_layer_1.PaginatedCollection({
                    transformer: (0, mobx_1.action)((res) => {
                        return res.items.map((ticket) => this.options.banks.intercomBank.upsert(ticket));
                    })
                });
                this.integrations = new ide_lib_reactor_data_layer_1.Collection();
                this.plans = new ide_lib_reactor_data_layer_1.Collection();
                this.containerDepotTokens = new ide_lib_reactor_data_layer_1.Collection();
                this.paymentConfigurations = new ide_lib_reactor_data_layer_1.Collection();
                this.billingDetails = null;
            }
            get org_id() {
                return this.model.id;
            }
            get label() {
                return this.model.label;
            }
            async loadBillingDetails() {
                this.billingDetails = await this.clients.provisionChargingStationClient().getBillingDetails({
                    org_id: this.id
                });
            }
            async updateBillingDetails(options) {
                await this.clients.provisionChargingStationClient().updateBillingDetails({
                    org_id: this.id,
                    ...options
                });
                await this.loadBillingDetails();
            }
            async updateLocks(lock) {
                await this.options.clients.provisionAccountsV5Client().updateOrgLocks({
                    id: this.org_id,
                    locked: lock
                });
                await this.reload();
            }
            async assignUser(user, role) {
                await this.options.clients
                    .provisionCardinalClient()
                    .assignRoleToUser({ user_id: user.options.model.id, role_id: role.id });
            }
            async loadRoles() {
                return this.roles.loadAll(() => {
                    return this.options.clients.provisionCardinalClient().listRoles.paginate({
                        org_id: this.id
                    });
                });
            }
            async loadContainerDepotTokens() {
                return this.containerDepotTokens.load(async () => {
                    const tokens = await this.options.clients.provisionContainerDepotClient().listTokens({
                        org_id: this.id
                    });
                    return tokens.map((m) => {
                        const model = new ContainerDepotTokenModel_1.ContainerDepotTokenModel({
                            clients: this.clients,
                            banks: this.options.banks,
                            model: m
                        });
                        const l = model.registerListener({
                            deleted: () => {
                                l === null || l === void 0 ? void 0 : l();
                                this.loadContainerDepotTokens();
                            }
                        });
                        return model;
                    });
                });
            }
            async loadApps() {
                return this.apps.loadAll(() => {
                    return this.options.clients.provisionAccountsV5Client().listApps.paginate({
                        org_id: this.id
                    });
                });
            }
            async loadTickets(options) {
                return this.tickets.loadAll(() => {
                    return this.options.clients.provisionIntercomClient().listTickets.paginate({
                        org_id: this.id,
                        status: options === null || options === void 0 ? void 0 : options.status
                    });
                });
            }
            async loadDevelopers() {
                return this.developers.loadAll(() => {
                    return this.options.clients.provisionAccountsV5Client().listUsers.paginate({
                        org_id: this.id
                    });
                });
            }
            async loadDeveloperInvites() {
                return this.developerInvites.loadAll(() => {
                    return this.options.clients.provisionAccountsV5Client().listDeveloperInvites.paginate({
                        org_id: this.id
                    });
                });
            }
            async loadIntegrations() {
                return this.integrations.load(async () => {
                    const integrations = await this.options.clients.provisionCerberusClient().listIntegrations({
                        org_id: this.org_id
                    });
                    return integrations.map((i) => {
                        return this.options.banks.integrationBank.upsert(i);
                    });
                });
            }
            async loadPaymentConfigurations() {
                return this.paymentConfigurations.load(async () => {
                    const configurations = await this.options.clients.provisionChargingStationClient().getPaymentConfigurations({
                        org_id: this.org_id
                    });
                    return configurations.map((i) => {
                        const model = new PaymentConfigurationModel_1.PaymentConfigurationModel({
                            model: i,
                            clients: this.clients,
                            org: this
                        });
                        model.registerListener({
                            deleted: () => {
                                this.loadPaymentConfigurations();
                            }
                        });
                        return model;
                    });
                });
            }
            async loadPlans() {
                return this.plans.load(async () => {
                    const res = await this.options.clients.provisionChargingStationClient().getPlans({
                        org_id: this.org_id
                    });
                    return res.map((i) => {
                        return this.options.banks.planBank.upsert(i, (model) => {
                            const l = model.registerListener({
                                deleted: () => {
                                    this.loadPlans();
                                    l();
                                }
                            });
                        });
                    });
                });
            }
            async createIntegration(integration) {
                const res = await this.options.clients.provisionCerberusClient().createIntegration({
                    ...integration,
                    org_id: this.id
                });
                this.loadIntegrations();
                return {
                    setup_url: res.setup_url,
                    id: res.integration.id
                };
            }
            async createRole(name) {
                const res = await this.options.clients.provisionCardinalClient().createRole({
                    name: name,
                    org_id: this.id,
                    policy_ids: []
                });
                this.loadRoles();
                return res.id;
            }
            async reload() {
                this.options.model = await this.options.clients.provisionAccountsV5Client().getOrg({
                    id: this.id
                });
            }
            app(id) {
                const app = this.options.banks.appsBank.item(id);
                if ((app === null || app === void 0 ? void 0 : app.model.org_id) !== this.id) {
                    return null;
                }
                return app;
            }
            integration(id) {
                return this.options.banks.integrationBank.item({
                    org_id: this.org_id,
                    id: id
                });
            }
            role(id) {
                const role = this.options.banks.roleBank.item(id);
                if ((role === null || role === void 0 ? void 0 : role.options.role.org_id) !== this.id) {
                    return null;
                }
                return role;
            }
            developer(id) {
                const dev = this.options.banks.developerBank.item(id);
                if ((dev === null || dev === void 0 ? void 0 : dev.options.model.org_id) !== this.id) {
                    return null;
                }
                return dev;
            }
            ticket(id) {
                const dev = this.options.banks.intercomBank.item({
                    id,
                    org_id: this.org_id
                });
                if ((dev === null || dev === void 0 ? void 0 : dev.options.ticket.org_id) !== this.id) {
                    return null;
                }
                return dev;
            }
            async getTicket(id) {
                await this.options.banks.intercomBank.resolve({
                    id,
                    org_id: this.org_id
                });
                return this.ticket(id);
            }
            async getDeveloper(id) {
                await this.options.banks.developerBank.resolve(id);
                return this.developer(id);
            }
            async getApp(id) {
                await this.options.banks.appsBank.resolve(id);
                return this.app(id);
            }
            async getRole(id) {
                await this.options.banks.roleBank.resolve(id);
                return this.role(id);
            }
            async getIntegration(id) {
                await this.options.banks.integrationBank.resolve({
                    org_id: this.org_id,
                    id: id
                });
                return this.integration(id);
            }
            async getResourceSelector() {
                return {
                    ...(await super.getResourceSelector()),
                    labels: {
                        locked: this.model.locked ? 'true' : 'false'
                    }
                };
            }
        },
        _OrganizationModel_billingDetails_accessor_storage = new WeakMap(),
        (() => {
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _billingDetails_decorators = [mobx_1.observable];
            __esDecorate(_a, null, _billingDetails_decorators, { kind: "accessor", name: "billingDetails", static: false, private: false, access: { has: obj => "billingDetails" in obj, get: obj => obj.billingDetails, set: (obj, value) => { obj.billingDetails = value; } }, metadata: _metadata }, _billingDetails_initializers, _billingDetails_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a;
})();
exports.OrganizationModel = OrganizationModel;
